if (!customElements.get('td-product-dimensions')) {
  class TdProductDimensions extends HTMLElement {
  
    constructor() {
      super();
      this.PRODUCT_DIMENSIONS_JSON = this.getJson(this.dataset.dimensionsJson);
      this.activeVariantId = this.dataset.activeVariantId;
      this.activeContent = null;
      
      this.DIMENSIONS_ELM = this.querySelector('[data-dimensions]');
      this.IMAGE_ELM = this.querySelector('[data-image]');
    }
  
    connectedCallback() {
      if (!this.PRODUCT_DIMENSIONS_JSON || !this.DIMENSIONS_ELM || !this.IMAGE_ELM) {
        console.warn('Missing product dimensions JSON or required elements.');
        return;
      }
      this.KEYED_DIMENSIONS_JSON = this.PRODUCT_DIMENSIONS_JSON.reduce((acc, item) => {
        acc[item.variantId] = item;
        return acc;
      }, {});
      this.attachListeners();
    }
  
    attachListeners() {
      document.addEventListener("pdp:variant-changed", (event) => {
        this.activeVariantId = event.detail?.variant?.id;
        this.setActiveContent();
        document.dispatchEvent(new CustomEvent("pdp:dimensions-updated"));
      });
    }
  
    setActiveContent() {
      this.activeContent = this.KEYED_DIMENSIONS_JSON[this.activeVariantId];
      if (this.activeContent) {
        this.DIMENSIONS_ELM.innerHTML = this.activeContent.dimensions;
        this.IMAGE_ELM.innerHTML = `<img src="${this.activeContent.dimensionsGraphic}" alt="A product dimensions graphic" />`;  
      }
      // Needed to trigger the accordion to resize when the image loads
      const img = this.IMAGE_ELM.querySelector('img');
      if (img) {
        img.addEventListener('load', () => {
          document.dispatchEvent(new CustomEvent('pdp:dimensions-updated'));
        });
      }
    }
  
    getJson(str) {
      try {
        return JSON.parse(str);
      } catch (err) {
        return null;
      }
    }
    
  }
  customElements.define('td-product-dimensions', TdProductDimensions);
}
